import React from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { Icon, Spinner } from "components/common";
import QueryValidationActions from "views/actions/QueryValidationActions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
export const SEARCH_BUTTON_WIDTH = "64";
const StyledButton = styled(Button)(
  ({ theme, $dirty }) => css`
    position: relative;
    min-width: ${SEARCH_BUTTON_WIDTH}px;

    ${$dirty ? css`
          &::after {
            position: absolute;
            content: '';
            height: 16px;
            width: 16px;
            top: -5px;
            right: -6px;
            border-radius: 50%;
            background-color: ${theme.colors.variant.warning};
          }
        ` : ""}
  `
);
const onButtonClick = (e, disabled, triggerTelemetry, onClick) => {
  onClick == null ? void 0 : onClick(e);
  if (disabled) {
    e.preventDefault();
    QueryValidationActions.displayValidationErrors();
  }
  triggerTelemetry();
};
const SearchButton = ({
  dirty = false,
  disabled = false,
  glyph = "search",
  displaySpinner = false,
  onClick = void 0
}) => {
  const sendTelemetry = useSendTelemetry("search-bar");
  const title = dirty ? "\u6267\u884C\u641C\u7D22\uFF08\u4E0A\u6B21\u641C\u7D22\u540E\u67E5\u8BE2\u5DF2\u4FEE\u6539\uFF09" : "\u6267\u884C\u641C\u7D22";
  const triggerTelemetry = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_BUTTON_CLICKED, {
      app_action_value: "search-button",
      event_details: {
        disabled
      }
    });
  };
  return /* @__PURE__ */ React.createElement(
    StyledButton,
    {
      onClick: (e) => onButtonClick(e, disabled, triggerTelemetry, onClick),
      title,
      disabled,
      allowClickWhenDisabled: true,
      type: "submit",
      bsStyle: "primary",
      showOverflow: true,
      $dirty: dirty && !displaySpinner
    },
    displaySpinner ? /* @__PURE__ */ React.createElement(Spinner, { delay: 0, text: "" }) : /* @__PURE__ */ React.createElement(Icon, { name: glyph, size: "lg" })
  );
};
export default SearchButton;
